(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RF-customsearch"] && !Shopify.designMode) return;
  try {
    
(() => {
  // ===== Config =====
  const USE_LOCAL_STORAGE = false; // keep false so we don't leave data in the browser
  const LS_KEY = 'RF-searchData';
  const lc = s => String(s ?? '').toLowerCase().trim();

  const cacheSet = (k,v)=>{ if(!USE_LOCAL_STORAGE) return; try{localStorage.setItem(k,JSON.stringify(v));}catch(_){} };
  const cacheGet = (k)=>{ if(!USE_LOCAL_STORAGE) return null; try{return JSON.parse(localStorage.getItem(k)||'null');}catch(_){return null;} };

  // Normalize keys (fixes "Brand " → "Brand")
  const normalizeKeys = (obj) => {
    const out = {};
    Object.keys(obj || {}).forEach(k => out[k.trim()] = obj[k]);
    return out;
  };

  // Parse inches from number, "7.125", "7-1/8", "7 1/8", '7"' etc.
  const parseInches = (v) => {
    if (v === '' || v == null) return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    let s = String(v).trim().replace(/[″”"']/g, '');
    const m = s.match(/^(\d+)?(?:[\s-]+(\d+)\s*\/\s*(\d+))?$/);
    if (m) {
      const whole = m[1] ? parseInt(m[1],10) : 0;
      const nume  = m[2] ? parseInt(m[2],10) : 0;
      const den   = m[3] ? parseInt(m[3],10) : 1;
      if (den) return whole + nume/den;
    }
    const f = parseFloat(s);
    return Number.isFinite(f) ? f : null;
  };
  const fmtInches = (x) => {
    if (x == null || !isFinite(x)) return '';
    const whole = Math.floor(x + 1e-6);
    const frac  = x - whole;
    const sixteenth = Math.round(frac * 16);
    if (sixteenth === 0) return `${whole}"`;
    if (sixteenth === 16) return `${whole+1}"`;
    const gcd=(a,b)=>b?gcd(b,a%b):a, g=gcd(sixteenth,16);
    return `${whole}-${sixteenth/g}/${16/g}"`;
  };

  // One initializer for each finder on the page
  const initFinder = (root) => {
    if (!root || root.dataset.inited === '1') return;
    root.dataset.inited = '1';

    const ASSET_URL = root.dataset.assetUrl || '';
    const $  = sel => root.querySelector(sel);
    const msgEl = $('.js-msg');
    const showMsg = t => { if (msgEl) msgEl.textContent = t; };

    // Tabs
    const tabs = root.querySelectorAll('.rf-tab');
    const panelProduct = root.querySelector('.rf-panel-product');
    const panelBrand   = root.querySelector('.rf-panel-brand');
    const panelSize    = root.querySelector('.rf-size-panel, .rf-panel-size');
    const setMode = (m) => {
      tabs.forEach(t => t.classList.toggle('is-active', t.dataset.mode === m));
      if (panelProduct) panelProduct.hidden = (m !== 'product');
      if (panelBrand)   panelBrand.hidden   = (m !== 'brand');
      if (panelSize)    panelSize.hidden    = (m !== 'size');
    };
    tabs.forEach(t => t.addEventListener('click', () => setMode(t.dataset.mode)));
    setMode('product');

    // -------- By Product (brands from products[]) --------
    const brandSelProducts = $('.js-brand-products');
    const skuSel           = $('.js-sku');
    const goProduct        = $('.js-go-product');
    const skuInput         = $('.js-sku-input');
    const skuGo            = $('.js-sku-go');
    const dataList         = root.querySelector('datalist');

    // -------- By Brand (collections from brands[]) --------
    const brandSelCollections = $('.js-brand-collections');
    const goCollection        = $('.js-go-collection');

    // -------- By Size (strict cross-filter) --------
    const diamSel = root.querySelector(`[id^="diamSelect-"]`);
    const lenSel  = root.querySelector(`[id^="lenSelect-"]`);
    const sizeGo  = root.querySelector(`[id^="sizeGo-"]`);
    const sizeMsg = root.querySelector(`[id^="rf-size-msg-"]`);
    const saySize = (t='') => { if (sizeMsg) sizeMsg.textContent = t; };
    const addOpts = (sel, values, placeholder) => {
      if (!sel) return;
      sel.innerHTML = '';
      const opt0 = document.createElement('option');
      opt0.value = '';
      opt0.textContent = placeholder;
      sel.appendChild(opt0);
      values.forEach(v => {
        const o = document.createElement('option');
        o.value = String(v);
        o.textContent = fmtInches(v);
        sel.appendChild(o);
      });
    };
    const tol = 0.001;
    const eq = (a,b) => a!=null && b!=null && Math.abs(a-b) <= tol;
    const num = (v) => { if (v === '' || v == null) return null; const n = Number(v); return Number.isFinite(n) ? n : null; };

    // ---- Size indexes/state
    let allDiams = [];
    let allLens  = [];
    const lengthsByDiam = new Map(); // diameter -> Set(lengths)
    const diamsByLength = new Map(); // length   -> Set(diameters)

    // State
    let data = null;
    const productsByBrand = Object.create(null);

    // Size mapping from brands sheet:
    // array of { brand, length: number|null, diameter: number|null, handle: string }
    let sizeLinks = [];

    // After data loads, populate all 3 modes
    const hydrate = (raw) => {
      const products = (Array.isArray(raw.products) ? raw.products : []).map(normalizeKeys);
      const brands   = (Array.isArray(raw.brands)   ? raw.brands   : []).map(normalizeKeys);
      data = { products, brands };

      // 1) By Product: build brand list FROM products only
      products.forEach(p => {
        const key = lc(p['Brand']);
        if (!key) return;
        (productsByBrand[key] ||= []).push(p);
      });
      const productBrands = Object.keys(productsByBrand)
        .map(k => (productsByBrand[k][0]?.['Brand'] || k))
        .sort((a,b)=>a.localeCompare(b));
      if (brandSelProducts) {
        const frag = document.createDocumentFragment();
        productBrands.forEach(name => {
          const opt = document.createElement('option');
          opt.value = name; opt.textContent = name;
          frag.appendChild(opt);
        });
        brandSelProducts.appendChild(frag);
      }

      brandSelProducts?.addEventListener('change', () => {
        if (!skuSel) return;
        skuSel.innerHTML = '';
        skuSel.disabled = true;

        const brand = brandSelProducts.value;
        if (!brand) return;

        const arr = productsByBrand[lc(brand)] || [];
        if (!arr.length) {
          const opt = document.createElement('option');
          opt.value = '';
          opt.textContent = `No parts found for ${brand}`;
          skuSel.appendChild(opt);
          return;
        }

        const seen = new Set();
        const options = arr.map(p => {
          const pn = String(p['Part Number'] || '').trim();
          const sk = String(p['SKU'] || '').trim();
          const title = String(p['Product Title'] || p['Title'] || '').trim();
          const handle= String(p['Product Handle'] || '').trim();
          const key   = pn || sk || handle;
          const display = title ? `${(pn||sk||handle)} — ${title}` : (pn||sk||handle);
          return key ? { key, display, handle } : null;
        }).filter(Boolean).filter(o => { if (seen.has(o.key)) return false; seen.add(o.key); return true; })
          .sort((a,b)=>a.display.localeCompare(b.display));

        const frag = document.createDocumentFragment();
        const ph = document.createElement('option'); ph.value=''; ph.textContent='Select a part / SKU…';
        frag.appendChild(ph);
        options.forEach(o => {
          const opt = document.createElement('option');
          opt.value = o.key; opt.textContent = o.display;
          if (o.handle) opt.dataset.handle = o.handle;
          frag.appendChild(opt);
        });
        skuSel.appendChild(frag);
        skuSel.disabled = false;
      });

      goProduct?.addEventListener('click', () => {
        const sel = skuSel?.selectedOptions?.[0] || null;
        const handle = sel?.dataset?.handle || '';
        const value  = sel?.value || '';
        if (value && handle) { location.href = `/products/${handle}`; return; }
        const q = brandSelProducts?.value || '';
        if (q) location.href = `/search?q=${encodeURIComponent(q)}`;
      });

      if (dataList) {
        const seen = new Set();
        products.forEach(p => {
          const pn = String(p['Part Number'] || '').trim();
          const sk = String(p['SKU'] || '').trim();
          [pn, sk].forEach(x => {
            if (x && !seen.has(x)) {
              const opt = document.createElement('option');
              opt.value = x; dataList.appendChild(opt); seen.add(x);
            }
          });
        });
      }
      const quickSearch = (rawQ) => {
        const q = String(rawQ || '').trim(); if (!q) return;
        const s = lc(q);
        const exact = products.find(p =>
          (p['Part Number'] && lc(p['Part Number']) === s) ||
          (p['SKU'] && lc(p['SKU']) === s)
        );
        if (exact?.['Product Handle']) { location.href = `/products/${exact['Product Handle']}`; return; }
        const partial = products.find(p => p['Part Number'] && lc(p['Part Number']).includes(s));
        if (partial?.['Product Handle']) { location.href = `/products/${partial['Product Handle']}`; return; }
        location.href = `/search?q=${encodeURIComponent(q)}`;
      };
      skuInput?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); quickSearch(skuInput.value); }});
      skuGo?.addEventListener('click', () => quickSearch(skuInput.value));

      // 2) By Brand (collections) — FROM brands[] only
      const brandCollections = brands
        .map(b => ({ name:String(b['Brand']||'').trim(), handle:String(b['Collection Handle']||'').trim() }))
        .filter(b => b.name && b.handle)
        .sort((a,b)=>a.name.localeCompare(b.name));
      if (brandSelCollections) {
        const frag = document.createDocumentFragment();
        brandCollections.forEach(b => {
          const opt = document.createElement('option');
          opt.value = b.handle; opt.textContent = b.name;
          frag.appendChild(opt);
        });
        brandSelCollections.appendChild(frag);
      }
      goCollection?.addEventListener('click', () => {
        const handle = brandSelCollections?.value || '';
        if (handle) location.href = `/collections/${handle}`;
      });

      // 3) By Size — strict cross-filter from products; redirect via brands' size mapping
      if (diamSel && lenSel && sizeGo) {
        lengthsByDiam.clear();
        diamsByLength.clear();

        const diamSet = new Set();
        const lenSet  = new Set();

        products.forEach(p => {
          const d = parseInches(p['Diameter'] ?? p['Diameter (in)'] ?? p['Dia'] ?? p['diameter']);
          const l = parseInches(p['Length']   ?? p['Length (in)']   ?? p['Len'] ?? p['length']);
          if (d != null) diamSet.add(d);
          if (l != null) lenSet.add(l);
          if (d != null && l != null) {
            if (!lengthsByDiam.has(d)) lengthsByDiam.set(d, new Set());
            lengthsByDiam.get(d).add(l);
            if (!diamsByLength.has(l)) diamsByLength.set(l, new Set());
            diamsByLength.get(l).add(d);
          }
        });

        allDiams = Array.from(diamSet).sort((a,b)=>a-b);
        allLens  = Array.from(lenSet ).sort((a,b)=>a-b);

        addOpts(diamSel, allDiams, 'Any diameter…');
        addOpts(lenSel,  allLens,  'Any length…');

        sizeGo.disabled = (allDiams.length === 0 && allLens.length === 0);
        saySize(sizeGo.disabled ? 'No size data found. Check "Length" and "Diameter" fields.' : '');

        // Cross-filter logic
        const refill = (sel, values, placeholder) => {
          const prev = sel.value;
          addOpts(sel, values, placeholder);
          if (prev) {
            const prevNum = Number(prev);
            if (values.some(v => Math.abs(v - prevNum) <= 0.001)) sel.value = prev;
          }
        };

        const updateLinked = () => {
          const dSel = diamSel.value === '' ? null : Number(diamSel.value);
          const lSel = lenSel.value  === '' ? null : Number(lenSel.value);

          if (dSel != null && lengthsByDiam.has(dSel)) {
            const lens = Array.from(lengthsByDiam.get(dSel)).sort((a,b)=>a-b);
            refill(lenSel, lens, 'Choose length…');
          } else {
            refill(lenSel, allLens, 'Any length…');
          }

          if (lSel != null && diamsByLength.has(lSel)) {
            const diams = Array.from(diamsByLength.get(lSel)).sort((a,b)=>a-b);
            refill(diamSel, diams, 'Choose diameter…');
          } else {
            refill(diamSel, allDiams, 'Any diameter…');
          }

          sizeGo.disabled = (!diamSel.value && !lenSel.value);
        };

        diamSel.addEventListener('change', updateLinked);
        lenSel .addEventListener('change', updateLinked);

        // Build sizeLinks from brands[] (S Length, S Diameter, Size Handles)
        sizeLinks = [];
        const get = (b, keys) => {
          for (const k of keys) { if (b[k] != null && String(b[k]).trim() !== '') return b[k]; }
          return null;
        };
        brands.forEach(b => {
          const slen = get(b, ['S length','S Length','Size Length','size length']);
          const sdia = get(b, ['S diameter','S Diameter','Size Diameter','size diameter']);
          const shan = get(b, ['Size Handle','Size handle','Size Handles','size handles']);
          const L = parseInches(slen);
          const D = parseInches(sdia);
          const handle = shan ? String(shan).trim() : '';
          if (!handle || (!Number.isFinite(L) && !Number.isFinite(D))) return;
          sizeLinks.push({ length: Number.isFinite(L) ? L : null, diameter: Number.isFinite(D) ? D : null, handle });
        });

        sizeGo.addEventListener('click', () => {
          const dSel = num(diamSel.value);
          const lSel = num(lenSel.value);
          if (dSel == null && lSel == null) return;

          // 1) Try mapping → unique collection handle
          const matchesLinks = sizeLinks.filter(rec => {
            const okD = (dSel == null) || (rec.diameter != null && eq(rec.diameter, dSel));
            const okL = (lSel == null) || (rec.length   != null && eq(rec.length,   lSel));
            return okD && okL;
          });
          const uniqHandles = Array.from(new Set(matchesLinks.map(m => m.handle).filter(Boolean)));
          if (uniqHandles.length === 1) {
            location.href = `/collections/${uniqHandles[0]}`;
            return;
          }

          // 2) Fallback to product (first exact size match)
          const prodMatch = data.products.find(p => {
            const d = parseInches(p['Diameter'] ?? p['Diameter (in)'] ?? p['Dia'] ?? p['diameter']);
            const l = parseInches(p['Length']   ?? p['Length (in)']   ?? p['Len'] ?? p['length']);
            const okD = (dSel == null) || (d != null && eq(d, dSel));
            const okL = (lSel == null) || (l != null && eq(l, lSel));
            return okD && okL && String(p['Product Handle']||'').trim();
          });
          if (prodMatch?.['Product Handle']) {
            location.href = `/products/${prodMatch['Product Handle']}`;
            return;
          }

          // 3) Final fallback → store search
          const parts = [];
          if (dSel != null) parts.push(`${fmtInches(dSel)} diameter`);
          if (lSel != null) parts.push(`${fmtInches(lSel)} length`);
          location.href = `/search?q=${encodeURIComponent(parts.join(' '))}`;
        });
      }
    };

    // Load data → hydrate
    if (!ASSET_URL) { showMsg('Missing data source.'); return; }
    const cached = cacheGet(LS_KEY);
    if (cached && (cached.products || cached.brands)) hydrate(cached);
    fetch(ASSET_URL, { cache: 'no-store' })
      .then(r => { if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(json => {
        const products = (Array.isArray(json.products) ? json.products : []).map(normalizeKeys);
        const brands   = (Array.isArray(json.brands)   ? json.brands   : []).map(normalizeKeys);
        const clean = { products, brands };
        cacheSet(LS_KEY, clean);
        hydrate(clean);
      })
      .catch(err => {
        if (!cached) showMsg('Data unavailable. Please try again soon.');
        console.warn('[RF] fetch failed', err);
      });
  };

  // Boot
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rf-finder[data-asset-url]').forEach(initFinder);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
